<template>
    <div class="mb-3" style="text-align: center;">
        <h2>** Important **</h2>
        <p>Since you're ordering merch, please enter the address you would like it delivered to, or if you would like to collect it at a future meet up</p>
        <textarea class="form-control" v-model="this.instructions" v-text="this.instructions"></textarea>
    </div>
    <button type="button" class="btn btn-warning m-2" @click="this.Save()">Update</button>
    <button type="button" v-if="this.length >= 12" class="btn btn-warning m-2 checkout-button">
        <a class="link-dark" href="/checkout">Go To Checkout</a>
    </button>
</template>

<script>

export default {

    data () {
        return {
            instructions: "",
            length: 0
        }
    },

    created () {
        this.instructions = this.shipping;
        this.length = this.instructions.length;
    },

    methods: {
        Save () {
            axios.post('/user/update_shipping', {
                value: this.instructions
            })
            .then( (response) => {
                this.length = response.data.characterCount;
            });
        }
    },

    props: ['shipping']

}

</script>